/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import { fetchProfile, switchProfile } from 'aurora-composition/modules/user/actions';
import { ADGMImage } from 'aurora-components';
import { useDispatch, useSelector } from 'react-redux';
import { keyEmptyCheck } from 'aurora-utils/utils';
import styles from './profileSwitch-jss';
import { enKeys, arKeys } from './langKeys';

function ProfileSwitch(props) {
  const { classes, title } = props;
  const dispatch = useDispatch();
  const user = useSelector(state => state.userReducer.user?.user);
  // const [user, setUser] = useState();
  const PERSONAL_ACCOUNT = 'profileSwitcher';
  const [activeProfile, setActiveProfile] = useState(PERSONAL_ACCOUNT);

  // localization
  const lang = localStorage.getItem('lang');
  const [langKeys, setlangKeys] = useState({});
  useEffect(() => {
    dispatch(fetchProfile());
  }, []);

  useEffect(() => {
    let activeCompanyId = null;
    if (user && user?.companyUserSubTypes?.length > 0)
      activeCompanyId = user?.companyUserSubTypes.filter(company => company.selected === true);
    activeCompanyId?.length > 0 ? setActiveProfile(activeCompanyId[0].companyId) : setActiveProfile(PERSONAL_ACCOUNT);
  }, [user]);

  useEffect(() => {
    // set langKeys
    if (lang === 'en') {
      setlangKeys(enKeys);
    } else {
      setlangKeys(arKeys);
    }
  }, [lang]);

  const ProfileCard = name => (
    <Typography type='body2' className={classes.primaryText}>
      {name}
    </Typography>
  );

  async function handleListItemClick(query, company) {
    if (company) {
      localStorage.setItem('userType', company[langKeys.subUserType]);
      localStorage.setItem('UserNameEn', company?.companyName);
      localStorage.setItem('UserNameBannerEn', company?.companyName);
      localStorage.setItem('UserNameBannerAr', company?.companyNameAr);
      localStorage.setItem('UserNameAr', company?.companyNameAr);
      if (
        company?.subUserType?.toLowerCase() === 'owner' ||
        company?.subUserType?.toLowerCase() === 'super_admin' ||
        company?.superAdmin === true
      ) {
        localStorage.setItem('companyUserRole', 'owner');
      } else {
        localStorage.removeItem('companyUserRole');
      }
      localStorage.setItem('selectedAccount', JSON.stringify(company));
      await dispatch(switchProfile(query));
    } else {
      localStorage.removeItem('companyUserRole');
      localStorage.setItem('userType', 'profileSwitcher');
      // localStorage.setItem('UserNameEn', company?.customerNameEn);
      // localStorage.setItem('UserNameAr', company?.customerNameAr);
      // localStorage.setItem('firstNameEn', company?.customerNameEn);
      // localStorage.setItem('firstNameAr', company?.customerNameAr);
      localStorage.setItem('UserNameBannerEn', company?.customerNameEn);
      localStorage.setItem('UserNameBannerAr', company?.customerNameAr);
      localStorage.setItem('selectedAccount', JSON.stringify(user));
      await dispatch(switchProfile(query));
    }
    window.location = `/${lang}/app/home`;
  }

  return (
    <>
      <Typography variant='h5' component='h2' className={classes.Title}>
        {title}
      </Typography>
      <div className={classes.GridFrame}>
        <List className={classes.switchProListHolder}>
          <ListItem
            button
            className={classNames(
              classes.switchProListitem,
              activeProfile === PERSONAL_ACCOUNT && classes.activeProfile,
            )}
            onClick={() => {
              if (activeProfile !== PERSONAL_ACCOUNT) {
                handleListItemClick(``);
              }
            }}
          >
            <ListItemAvatar>
              <ADGMImage className={classes.avatar} name='avatar_profile.svg' />
            </ListItemAvatar>
            <ListItemText
              primary={ProfileCard(`${user?.[langKeys.customerName]}`)}
              secondary={keyEmptyCheck(PERSONAL_ACCOUNT)}
            />
            <ADGMImage name={activeProfile === PERSONAL_ACCOUNT ? 'check-solid.svg' : 'profile_switch.svg'} />
          </ListItem>

          {user?.companyUserSubTypes?.length > 0 &&
            user?.companyUserSubTypes.map(company => (
              <ListItem
                key={company.companyId}
                button
                className={classNames(
                  classes.switchProListitem,
                  activeProfile === Number(company[langKeys.companyId]) && classes.activeProfile,
                )}
                onClick={() => {
                  if (activeProfile !== Number(company[langKeys.companyId])) {
                    handleListItemClick(`?companyId=${company[langKeys.companyId]}`, company);
                  }
                }}
              >
                <ListItemAvatar>
                  <ADGMImage className={classes.avatar} name='company_profile.svg' />
                </ListItemAvatar>
                <ListItemText
                  primary={ProfileCard(company[langKeys.companyName])}
                  secondary={keyEmptyCheck(company?.subUserType)}
                />
                <ADGMImage
                  name={
                    activeProfile === Number(company[langKeys.companyId]) ? 'check-solid.svg' : 'profile_switch.svg'
                  }
                />
              </ListItem>
            ))}
        </List>
      </div>
    </>
  );
}

ProfileSwitch.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
};

export default withStyles(styles)(injectIntl(ProfileSwitch));
